import { InfoTextArea } from './InfoAnswer.styles';

interface IProps {
    value: string;
    onChange: (value: string) => void;
}

const InfoAnswer: React.FC<IProps> = ({ value, onChange }) => {
    return (
        <InfoTextArea rows={5} value={value} onChange={(e) => onChange(e.target.value)}>
        </InfoTextArea>
    );
};

export default InfoAnswer;
